<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-4">
            <input type="search" class="form-control input-sm" placeholder="Search clients" v-model="searchQuery" aria-controls="datatables"><br>
        </div>
        <div class="col-sm-1">
          <h5><i class="fa fa-spinner fa-pulse" v-if="searching"></i></h5>
        </div>
        <div class="col-sm-4">
            <el-select class="select-success"
                       size="small"
                       v-model="searchLimit"
                       @change="updatePerPage($event)">
                <el-option
                  v-for="item in searchLimits"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped"
                    :data="queriedData"
                    :default-sort="getDefaultSort()"
                    border
                    style="width: 100%"
                    @sort-change="updateSortOrder">
            <template slot="empty">
                <p>Search for a client by first or last name or exact tribal ID</p>
            </template>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             :formatter="column.formatter"
                             sortable="custom">
            </el-table-column>
            <el-table-column
              :min-width="50"
              label="View">
              <template slot-scope="props">
                <a class="btn btn-simple btn-xs btn-info btn-icon like" @click="lookupClient(props.row.ClientId)"><i class="ti-eye"></i></a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{fromDisplay}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
           <el-pagination class="pull-right" layout="prev, pager, next" :page-size="this.perPage" :total="this.total" @current-change="updatePageNumber"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, Pagination} from 'element-ui'
  import moment from 'moment'
  import viewClientMethod from 'src/components/Dashboard/Views/Dashboard/ViewClient'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Pagination)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    computed: {
      queriedData () {
        if (!this.searchQuery || this.searchQuery.length < 2) {
          // this.results === null is for initial load
          // previousQuery != searchQuery is when query is cleared to nothing.
          if (this.results === null || this.previousQuery !== this.searchQuery) {
            this.refreshData()
            this.previousQuery = this.searchQuery
          }
        } else if (this.previousQuery !== this.searchQuery) {
          this.previousQuery = this.searchQuery
          this.searchCount++
          let currentCheck = this.searchCount
          setTimeout(() => {
            if (this.searchQuery.length >= 2 && this.searchCount === currentCheck) { // Check closure of searchCount to see if done typing
              this.refreshData()
            }
          }, 200)
        }
        return this.tableData
      },
      to () {
        return !this.results ? 0 : this.results.to
      },
      from () {
        return !this.results ? 0 : this.results.from
      },
      fromDisplay () {
        return this.from
      },
      total () {
        return this.results ? this.results.total : 0
      }
    },
    data () {
      return {
        perPage: 100,
        currentPage: 1,
        searchCount: 0,
        searching: false,
        searchQuery: '',
        sortOrder: 'Name',
        sortDirection: 'ASC',
        searchLimit: 100,
        searchLimits: [
          {
            value: 100,
            label: '100'
          },
          {
            value: 500,
            label: '500'
          },
          {
            value: 'all',
            label: 'All'
          }
        ],
        previousQuery: '',
        propsToSearch: ['Name', 'TribalId', 'DOB'],
        tableColumns: [
          {
            prop: 'Name',
            label: 'Name',
            minWidth: 200
          },
          {
            prop: 'TribalId',
            label: 'Tribal ID',
            minWidth: 90
          },
          {
            prop: 'DOB',
            label: 'Birthdate',
            minWidth: 110,
            formatter: (row, column, cellValue) => {
              let date = moment(cellValue, 'YYYY-MM-DD')
              return date.format('MM/DD/YYYY') + ' (' + moment().diff(date, 'years') + ')'
            }
          },
          {
            prop: 'GuardianName',
            label: 'Guardian',
            minWidth: 150
          },
          {
            prop: 'SSN',
            label: 'SSN',
            minWidth: 70
          },
          ...(this.$store.state.managerData.GroupId === 0
          ? [{
            prop: 'GroupName',
            label: 'Tribe',
            minWidth: 120
          }] : [])
        ],
        tableData: [],
        results: null
      }
    },
    methods: {
      viewClient: viewClientMethod,
      lookupClient: function (clientId) {
        this.$http.get('/manager/viewClient/' + clientId)
          .then(response => {
            this.viewClient(response.data)
          })
      },
      getDefaultSort: function () {
        return (
          { prop: this.sortOrder, order: 'ascending' }
        )
      },
      // Handler when the page limit is changed
      updatePerPage: function (newPerPage) {
        // If all, it is updated when results are received
        if (this.searchLimit !== 'all') {
          this.perPage = this.searchLimit
        }
        this.refreshData()
      },
      // Handler when the sort order is changed
      updateSortOrder: function (e) {
        this.sortDirection = e.order === 'descending' ? 'DESC' : 'ASC'
        this.sortOrder = e.prop
        this.refreshData()
      },
      // Handler when the page number to show is changed
      updatePageNumber (val) {
        this.currentPage = val
        this.refreshData()
      },
      refreshData: function () {
        var url = '/manager/searchClients/' + this.sortOrder + '/' + this.sortDirection
        if (this.searchQuery !== '') {
          url += '/' + this.searchQuery
        }
        url += '?page=' + this.currentPage + '&limit=' + this.searchLimit
        this.searching = true
        this.$http.get(url)
        .then(response => {
          this.searching = false
          this.results = response.data
          this.tableData = response.data.data
          // Make sure that the perPage is updated (for pagination information)
          // when it is 'all'
          if (this.searchLimit === 'all') {
            this.perPage = this.results.total
          }
        })
      }
    },
    created: function () {
      this.viewClient = this.viewClient.bind(this)
    }
  }
</script>
<style>
.el-table .cell {
  word-break: normal;
  overflow-wrap: normal;
}
.el-pager .number {
  border-radius: 20px;
  border: 2px solid black;
  height: 36px;
  color:  #66615B;
  margin: 0px 2px;
}
.el-pager .number.active {
  border-radius: 20px;
  border: 2px solid black;
  height: 36px;
  background-color: #66615B;
  border-color: #66615B;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/AccountView.vue